module.exports = __webpack_public_path__ + "img/CambridgeUniversityPressWhiteLogo.ae10c2b.svg";